import React, { useEffect, useRef, useState } from 'react'
import { Form, Row, Col, Button, Spinner, Card } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import ServerError from '../../controls/ServerError';
import DataGrid from '../../controls/DataGrid.js/DataGrid';
import DynamicDropdownSearchableForClient from '../../controls/DynamicDropdownSearchableForClient';
import DynamicDropdownSearchable from '../../controls/DynamicDropdownSearchable';
import DatePicker from "react-datepicker";
import { getDateSaveFormat } from '../../../Utils';
export default function TicketSearchForm({ afterSave, onCancel }) {
    const state = useSelector(state => state);
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [showTicketList, setshowTicketList] = useState(false);
    const firstnameRef = useRef(null);
    const [pcpUser, setpcpUser] = useState(false);
    const [dropdwnInitialValue, setdropdwnInitialValue] = useState("---Select All---");
    const [querystring, setquerystring] = useState("");
    const [createdbyChanged, setcreatedbyChanged] = useState(false);
    const formref = useRef(null);
    const [dropdownvalue, setdropdownvalue] = useState({
        UserId: 0,
    })
    const [inputValue, setInputValue] = useState({
        // DOB:null,
        fkTicketTypeId: "",
        TicketNumber: "",
        fkFunctionalAreaId: "",
        fkTicketStatusId: "",
        IssueOwnerId: "",
        CreatedDate :new Date()
    });
    const [serverError, setServerError] = useState({});
    const handleChange = ((e) => {
        const name = e.target.name;
        let value = e.target.value.trim();
        let maxLength = e.target.maxLength;
        if (e.target.type == "checkbox") {
            value = e.target.checked;
        }
        else {
            if (maxLength && maxLength > 0 && value.length > maxLength) {
                return;
            }
        }
        setInputValue(c => ({ ...c, [name]: value }));
    });
    useEffect(() => {
       // firstnameRef.current.focus();
        setshowTicketList(false);
        let loggedinUser = JSON.parse(localStorage.getItem("user"));
        if (loggedinUser.fkRoleId == 3) {
            setpcpUser(true);
            setdropdownvalue(c => ({ ...c, ["UserId"]: loggedinUser.Id }));
            inputValue.CreatedBy = loggedinUser.Id;
        }

    }, []);

    const handleSubmit = ((e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        console.log(inputValue);
        if (inputValue.TicketNumber.trim() === "" && inputValue.fkFunctionalAreaId.trim() === ""
            && inputValue.fkTicketTypeId.trim() === "" && inputValue.IssueOwnerId === 0
            && inputValue.fkTicketStatusId === "" 
        ) {
            window.alert("Please enter Ticket Number or functional type or Ticket type or Created By or Ticket Status ");
           // firstnameRef.current.focus();
            setshowTicketList(false);
            return false;
        }
        if (form.checkValidity() === false) {
            setValidated(true);
        }
        else {

            let loggedinUser = JSON.parse(localStorage.getItem("user"));
            let UserId = 0;
            if (loggedinUser?.fkRoleId != 3) {
                UserId = 0
            } else {
                UserId = loggedinUser?.Id;
            }
            setquerystring(new URLSearchParams({
                TicketNumber: inputValue.TicketNumber,
                fkFunctionalAreaId: inputValue.fkFunctionalAreaId,
                fkTicketStatusId: inputValue.fkTicketStatusId,
                fkTicketTypeId: inputValue.fkTicketTypeId,
                IssueOwnerId: inputValue.IssueOwnerId,
                CreatedDate: inputValue.CreatedDate
               // UserId: UserId
            }).toString());
        }

        let updatedQueryStr = "TicketNumber=" + inputValue.TicketNumber + "&&" +
            "fkFunctionalAreaId=" + inputValue.fkFunctionalAreaId + "&&" +
            "fkTicketStatusId=" + inputValue.fkTicketStatusId + "&&" +
            "fkTicketTypeId=" + inputValue.fkTicketTypeId + "&&" +
            "IssueOwnerId=" + inputValue.IssueOwnerId + "&&" +
            "CreatedDate=" + getDateSaveFormat(inputValue.CreatedDate);

        console.log(querystring);
        setquerystring(updatedQueryStr);
        console.log(querystring);
       // setshowTicketList(true);
        afterSave(inputValue);
    })
    const options = {
        dataType: "server",
        showExport: true,
        showRefresh: true,
        sortName: "CreatedDate",
        sortOrder: "desc",
        exportDocumetName: "Tickets",
        inputvalue: inputValue
    };
    const columns = [
        {
            field: "TicketNumber",
            title: "Ticket Number",
            sortName: "TicketNumber",
            sortable: true,
        },
        {
            field: "FunctionalArea.Description",
            title: "Functional Area",
            sortable: true,
        },
        {
            field: "TicketType.Description",
            title: "Ticket Type",
            sortable: true,
        },
        {
            field: "TicketStatus.Description",
            title: "Ticket Status",
            sortable: true,

        },
        {
            field: "user.name",
            title: "Created By",
            sortable: false,
        },
        {
            field: "CreatedDate",
            title: "Created Date",
            sortable: true,
        },

    ];

    const handleDropdownChange = (e) => {

        let value = e.target.value;
        setcreatedbyChanged(true);
        if (value > 0) {
            setInputValue(c => ({ ...c, "IssueOwnerId": value }));
            setdropdownvalue(c => ({ ...c, "IssueOwnerId": value }));
            inputValue.CreatedBy = value;
        }
        else {
            inputValue.CreatedBy = "";
            setInputValue(c => ({ ...c, "IssueOwnerId": "" }));
            setdropdownvalue(c => ({ ...c, "IssueOwnerId": value }))
        }
    };
    const handleFunctionalArea = (e) => {
        if (e.target.options[e.target.selectedIndex].text !== "") {
           let value = e.target.options[e.target.selectedIndex].value;
            setInputValue(input => ({ ...input, "fkFunctionalAreaId": value }))
           
        } else {
            setInputValue(input => ({ ...input, "fkFunctionalAreaId": '' }))
        }
    }
    const handleTypeofTicket = (e) => {
        if (e.target.options[e.target.selectedIndex].text !== "") {
            let value = e.target.options[e.target.selectedIndex].value;
            setInputValue(input => ({ ...input, "fkTicketTypeId": value }))

        } else {
            setInputValue(input => ({ ...input, "fkTicketTypeId": '' }))
        }
    }
    const handleTicketStatus = (e) => {
        if (e.target.options[e.target.selectedIndex].text !== "") {
            let value = e.target.options[e.target.selectedIndex].value;
            setInputValue(input => ({ ...input, "fkTicketStatusId": value }))

        } else {
            setInputValue(input => ({ ...input, "fkTicketStatusId": '' }))
        }
    }

    const handleCreatedBy = (e) => {
        if (e.target.options[e.target.selectedIndex].text !== "") {
            let value = e.target.options[e.target.selectedIndex].value;
            setInputValue(input => ({ ...input, "IssueOwnerId": value }))

        } else {
            setInputValue(input => ({ ...input, "IssueOwnerId": '' }))
        }
    }
    const handleDatePickerChange = ((value, name) => {
        let dataObj = { ...inputValue };
        dataObj[name] = value;
        if (name == "CreatedDate") {
            let NewDate = new Date(value);
            NewDate.setFullYear(NewDate.getFullYear() + 1);
            NewDate.setDate(NewDate.getDate() - 1);
            dataObj["CreatedDate"] = NewDate;
            inputValue.CreatedDate = NewDate;
            setInputValue(inputValue => ({ ...inputValue, [name]: value }));
       
        }
        //setData(c => ({ ...c, ...dataObj }));
        //dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    })


    return (
        <Form noValidate validated={validated} ref={formref} onSubmit={handleSubmit} >

            <Row className="mb-3" >
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Ticket Number</Form.Label>
                        <Form.Control type="text" name="TicketNumber" value={inputValue.TicketNumber} onChange={handleChange} autoComplete="off" />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Created Date</Form.Label>
                        <DatePicker required={true} className="form-control" selected={inputValue.CreatedDate} onChange={(val) => (handleDatePickerChange(val, "CreatedDate"))}
                            showYearDropdown
                            showMonthDropdown
                            dateFormat="MM-dd-yyyy"
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col md={6}>

                    <Form.Group>
                        <Form.Label>Ticket Type</Form.Label>
                        <DynamicDropdownSearchable required={true} from={state.projectdetail.API + "/Misc/GetDescription?category=TicketType"} label="Description" value="Id" fetchType="get" name="fkTicketTypeId" onDropdownChange={handleTypeofTicket} />
                    </Form.Group>

                </Col>
                <Col md={6}>

                    <Form.Group>
                        <Form.Label>Ticket Status</Form.Label>
                        <DynamicDropdownSearchable required={true} from={state.projectdetail.API + "/Misc/GetDescription?category=Ticket Status"} label="Description" value="Id" fetchType="get" name="fkTicketStatusId"  onDropdownChange={handleTicketStatus}  />
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={6}>
                    <Form.Label>Created By</Form.Label>
                    <DynamicDropdownSearchableForClient from={state.projectdetail.API + "/User/GetAllActiveUsers"} label="name" value="Id" fetchType="get" name="IssueOwnerId" onDropdownChange={handleCreatedBy} />

                </Col>
                <Col md={6}>

                    <Form.Group>
                        <Form.Label>Functional Area</Form.Label>
                        <DynamicDropdownSearchable required={true} from={state.projectdetail.API + "/Misc/GetDescription?category=Functional Area"} label="Description" value="Id" fetchType="get" name="fkFunctionalAreaId" onDropdownChange={handleFunctionalArea} />
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12}>
                    <ServerError error={serverError} />
                </Col>
            </Row>
            <Row className="mb-3">
                <Col md={9}></Col>
                <Col className='text-center' md={3}>
                    <Button variant="outline-primary" onClick={onCancel} disabled={loading}>
                        Cancel
                        {loading ? <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" /> : ""}
                    </Button>&nbsp;&nbsp;
                    <Button variant="primary" type="submit" disabled={loading}>
                        Search
                        {loading ? <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" /> : ""}
                    </Button>
                </Col>
            </Row>
            {showTicketList &&
                <Row className="mb-6">
                    <Col md={12}>
                        <h4 >
                            Ticket List
                        </h4>
                    </Col>
                </Row>
            }
            {showTicketList &&
                <Row className="mb-6">
                    <Card>
                        <Card.Body>
                            {loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> : ""}
                            <DataGrid url={state.projectdetail.API + "/Ticket/SearchTicketGrid?" + querystring} classes="table table-striped" options={options} columns={columns} refresh={refreshGrid} />

                        </Card.Body>
                    </Card>
                </Row>
            }

        </Form>
    )
}
